import React from 'react';
import { useSelector, Provider } from 'react-redux';

import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline, StyledEngineProvider } from '@material-ui/core';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
// import ErrorSnackbar from 'ui-component/extended/ErrorSnackbar';
import MenuDetailsProvider from "./contexts/MenuDetailsProvider";

// auth provider
// import { FirebaseProvider } from 'contexts/FirebaseContext';
import { TakyonProvider } from 'contexts/TakyonContext';
import { TakyonFirebaseProvider } from 'contexts/TakyonFirebaseContext';
// import {JWTProvider} from 'contexts/JWTContext';
// import {Auth0Provider} from 'contexts/Auth0Context';
// import { createMyStore } from './reducers/create-store';

// ===========================|| APP ||=========================== //

const App = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
              <MenuDetailsProvider>
                <CssBaseline />
                {/* RTL layout */}
                {/* <RTLLayout> */}
                <TakyonFirebaseProvider>
                <Locales>
                    <NavigationScroll>
                        <TakyonProvider>
                            <Routes />
                            <Snackbar />
                        </TakyonProvider>
                    </NavigationScroll>
                </Locales>
                </TakyonFirebaseProvider>
                {/* </RTLLayout> */}
              </MenuDetailsProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
